import kkpService from '../services/kkpService';
import { matchCommercialOption } from './matchCommercialOption';

export async function resolveCommercialSelectionFromDolibarrClient(client, commercialOptions = []) {
  const thirdpartyId = Number(client?.id) || 0;
  if (thirdpartyId <= 0 || !Array.isArray(commercialOptions) || commercialOptions.length === 0) {
    return null;
  }

  const detail = await kkpService.getDolibarrClient(thirdpartyId);

  return matchCommercialOption(commercialOptions, {
    commercial_id: Number(detail?.commercial_id) > 0 ? Number(detail.commercial_id) : null,
    commercial_nom: String(detail?.commercial_nom ?? '').trim(),
    commercial_email: String(detail?.commercial_email ?? '').trim(),
    commercial_emails: Array.isArray(detail?.commercial_emails) ? detail.commercial_emails : [],
  });
}
